import * as React from 'react';
import { DefaultGraphProps } from '../Report';
import { Chart } from 'devextreme-react';
import { Series, ValueAxis, Tooltip, CommonSeriesSettings, Legend, Label, Title, CommonAxisSettings, Grid, Margin, ArgumentAxis, Format, Export, BreakStyle } from 'devextreme-react/chart';
import * as moment from 'moment';
import { DXDatasourceData } from 'src/api/endpoints/client';

function weekIndexToDate(index: number) {
    return moment(new Date(-2208960000000)).add(index, 'week').toDate().toLocaleDateString()
}

function dayIndexToDate(index: number) {
    return moment(new Date(-2208960000000)).add(index, 'day').toDate().toLocaleDateString()
}

function monthIndexToDate(index: number) {
    return moment(new Date(-2208960000000)).add(index, 'month').toDate().toLocaleDateString()
}

export default class ReportComponentChart extends React.Component<DefaultGraphProps, {
    height?: number,
    width?: number
}> {
    chart: Chart | null;

    constructor(p: DefaultGraphProps) {
        super(p);
        this.state = {

        }
    }

    didUpdateSize(initial: boolean = false) {
        this.chart && this.chart.instance.refresh()
    }

    render() {
        const { source } = this.props as { source: DXDatasourceData }
        return <Chart ref={(ref) => this.chart = ref} style={{ height: '100%', width: '100%' }}
            palette='Office'
            width='100%'
            dataSource={source.source}>
            <ValueAxis>
                <Label />
            </ValueAxis>
            <CommonSeriesSettings
                argumentField="index"
                type={'spline'}
            />
            <CommonAxisSettings>
                <Grid visible={true} />
            </CommonAxisSettings>
            {
                source.series.map(function (item) {
                    return <Series key={item} valueField={item} name={item} />;
                })
            }
            <Margin bottom={20} />
            <ArgumentAxis
                allowDecimals={false}
                axisDivisionFactor={60}>
                <Label customizeText={(e: any) => {
                    switch (source.index_type) {
                        case 'daily':
                            return dayIndexToDate(e.value)
                        case 'monthly':
                            return monthIndexToDate(e.value)
                        default:
                            return weekIndexToDate(e.value)
                    }

                }}>
                    <Format type="datetime" />
                </Label>
            </ArgumentAxis>
            <Legend visible position='inside' customizeText={(e: any) => {
                return (e.seriesName).replace('<', '').replace('>', '')
            }}
            />
            <Export enabled={true} />
            <Tooltip enabled={true} />
            <Title text={source.title}>
            </Title>
        </Chart>
    }
}


// WEBPACK FOOTER //
// ./src/components/ReportComponents/ReportComponentChart.tsx